module.exports = __webpack_public_path__ + "static/media/InviteGuests.a007d11a.svg";